import { safeClone, SpyneAppProperties, SpyneTrait } from "spyne";
import {
  clone,
  compose,
  defaultTo,
  filter,
  head,
  path,
  prop,
  propEq,
  whereEq,
} from "ramda";

export class AppDataTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "api$";
    super(context, traitPrefix);
  }

  static api$GetLocalImg(fileName) {
    return `${IMG_PATH}${fileName}`;
  }

  static api$GetPageFn() {
    return (page) =>
      compose(
        safeClone,
        defaultTo({}),
        head,
        filter(propEq(page, "pageId")),
        defaultTo([]),
        prop("content"),
      );
  }

  static api$GetCardFn() {
    return (card) =>
      compose(
        clone,
        head,
        filter(propEq(card, "cardId")),
        defaultTo([]),
        prop("content"),
      );
  }

  static api$GetCard(pageId, cardId, data = this.props.data) {
    const getPageFn = AppDataTraits.api$GetPageFn();
    const getCardFn = AppDataTraits.api$GetCardFn();
    return compose(getCardFn(cardId), getPageFn(pageId))(data);
  }


  static api$GetAuthStateFromAuth0AndStripe(){
    const getParamVal = ()=>{

      const params = new URLSearchParams(window.location.search);

      // intent always takes priority over upgrade (pre-login intent > result)
      if (params.has("intent")) {
        return params.get("intent");
      }

      if (params.has("upgrade")) {
        return params.get("upgrade");
      }

      return null;

    }

    const authState = getParamVal();
    const authIntent = localStorage.getItem('postAuthIntent');

    const authStageMap = {
      successValidated : authState === 'success' && authIntent === 'upgrade_pro_validate'
    }
    const { successValidated } = authStageMap;

    return {authState, authIntent, successValidated}

  }




  static api$GetPage(pageId, d = this.props.data) {
    const data = AppDataTraits.api$GetPageFn()(pageId)(d);
    data["linksData"] = data.content;
    //console.log("GET PAGE ",{pageId, data, d}, this.props);
    if (pageId === "docs") {
      data.spyneDocsData = this.props.spyneDocsData;
    }

    return data;
  }

  static api$GetLinksDataset(propsObj) {
    const linkDatasets =
      SpyneAppProperties.getChannelConfig("ROUTE").routeDatasetsArr;
    return compose(
      head,
      defaultTo([{}]),
      filter(whereEq(propsObj)),
    )(linkDatasets);
  }

  static api$GetNavLinks(level) {
    const navLinksData = SpyneAppProperties.getChannelConfig("ROUTE");
    const data = prop("routeDatasetsArr", navLinksData);
    //console.log("data is ", data);
    return level === undefined
      ? data
      : compose(filter(propEq(level, "navLevel")))(data);
  }

  static api$MapData(d) {
    const addLocalImgPath = (o) => {
      o["bgImg"] = AppDataTraits.api$GetLocalImg(
        path(["image", "fileName"], o),
      );
      if (Array.isArray(o.content)) {
        o.content.map(addLocalImgPath);
      }
      return o;
    };

    d.content.map(addLocalImgPath);

    return clone(d);
  }
}
